import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { ACCOUNT_TYPES } from 'utils/constants'

const fieldRequiredMsg = 'This field is required'

export const locationsSchema = {
  locationsArray: Yup.array().of(
    Yup.object().shape({
      name: Yup.string()
        .nullable()
        .when('accountType', {
          is: !ACCOUNT_TYPES.CARRIER.id,
          then: Yup.string().nullable().required(fieldRequiredMsg),
        }),
      locationType: Yup.string().nullable(), // REMOVE this line when "enableAddressPrintingUpdates" FF is turned on
      locationTypes: Yup.array().of(Yup.string()), // KEEP this line when "enableAddressPrintingUpdates" FF is turned on
      address1: Yup.string()
        .nullable()
        .when('accountType', {
          is: !ACCOUNT_TYPES.CARRIER.id,
          then: Yup.string().nullable().required(fieldRequiredMsg),
        }),
      address2: Yup.string().nullable(),
      city: Yup.string().nullable(),
      state: Yup.string().nullable(),
      zip: Yup.string().nullable(),
      country: Yup.string().nullable(),
      notes: Yup.string().nullable(),
      primaryContactId: Yup.string().nullable(),
      freightPricing: Yup.object()
        .shape({
          id: Yup.string().nullable(),
          consumerFreightEnabled: Yup.boolean().nullable(),
          supplierFreightEnabled: Yup.boolean().nullable(),
          consumerFreightChargeback: Yup.number().nullable(),
          supplierFreightChargeback: Yup.number().nullable(),
          consumerFreightCost: Yup.mixed(),
          supplierFreightCost: Yup.number().nullable(),
          locationId: Yup.string().nullable(),
        })
        .nullable(),
    }),
  ),
}

const validationSchema = Yup.object().shape({
  locations: locationsSchema.locationsArray,
})

export const formOptions = { resolver: yupResolver(validationSchema) }

export default validationSchema
